module.exports = "/_next/static/images/CharlesHouser-dbdd9745c54b67fcd6d8f8e115d28968.webp";